module.exports = __webpack_public_path__ + "img/filter_pan.26a4c04a.svg";